<template>
  <material-card
    class="v-card--material-stats"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #subtitle>
      <div
        class="text-right text-h3 v-card__subtitle--material-stats"
        v-text="value"
      />
    </template>

    <template #actions>
      <slot name="actions" />
    </template>

    <slot />
  </material-card>
</template>

<script>
export default {
  name: "MaterialStatCard",

  props: { value: String }
};
</script>

<style lang="sass">
.v-card--material-stats.v-card--material .v-card--material__title
  color: #999999
  font-size: .875rem !important
  text-align: right
  white-space: normal
  overflow-wrap: anywhere
  word-break: break-word
  line-height: 1.2
  max-width: 100%

.v-card__subtitle--material-stats
  color: #3C4858

@media (max-width: 600px)
  .v-card--material-stats.v-card--material .v-card--material__title
    font-size: .8rem !important
</style>
